import { useEffect, useState, useRef } from "react";
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import axios from "axios";
import CommonValues from "../Common/utils";
import { Guid } from "js-guid";
import { Loader } from "lucide-react";

export default function ScalePage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const [saveLoading, setSaveLoading] = useState(false);
  const toast: any = useRef("");
  const [transactionId, setTransactionId] = useState("");

  const onSidebarClick = (val: any) => {
    setSidebarOpen(val);
  };

  const onProceedToQuestionClick = () => {
    setSaveLoading(true);
    const transactionsid = Guid.newGuid().toString();
    setTransactionId(transactionsid);
    var data = {
      transactionId: transactionsid,
      questionnaire: "",
      diagnosticScore: "",
      completedDate: null,
    };
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_MAPSAPI}/api/account/questionnaire`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "Application/json",
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        navigate("/question", {
          state: { transactionsid },
        });
      })
      .catch((error: any) => {
        setSaveLoading(false);
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } 
          // else if (error.response.status === 404) {
          //   toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error while proceeding to question", life: 3000 });
          // } else {
          //   toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error while proceeding to question", life: 3000 });
          // }
        }
      });
  };
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Toast ref={toast} />
      <Sidebar pagename="agency-information" onSidebarClick={() => onSidebarClick(false)} sidebarOpen={sidebarOpen} />
      {/* Main Content */}
      <main className="flex-1 h-screen overflow-y-auto p-4 md:p-8">
        <Header onSidebarClick={() => onSidebarClick(true)} />

        <div className="flex flex-col min-h-[calc(100vh-185px)] justify-center items-center">
          <div className="bg-white rounded-lg shadow-md p-6 max-w-3xl w-full">
            <div className="border border-green-300 bg-green-50 rounded-md mt-6 p-6">
              <h2 className="font-semibold text-lg text-green-800 mb-2">Diagnostic Scale</h2>
              <p className="mb-4">For all questions, please use the following 5-point scale:</p>
              <ul className="space-y-2 text-gray-800">
                <li>
                  <span className="font-bold ">1. Strongly Disagree</span> – This is a significant weakness in our organization
                </li>
                <li>
                  <span className="font-semibold">2. Disagree</span> – This is somewhat of a weakness in our organization
                </li>
                <li>
                  <span className="font-semibold">3. Neutral</span> – We are neither strong nor weak in this area
                </li>
                <li>
                  <span className="font-semibold">4. Agree</span> – This is somewhat of a strength in our organization
                </li>
                <li>
                  <span className="font-bold ">5. Strongly Agree</span> – This is a significant strength in our organization
                </li>
              </ul>
              {saveLoading ? (
                <div className="flex justify-center mt-4">
                  <Loader className="h-8 w-8 text-green-500 animate-spin" />
                </div>
              ) : (
                <button
                  className="mt-6 w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded transition"
                  onClick={onProceedToQuestionClick}
                >
                  Proceed to Questions
                </button>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
